import colors from "coral-ui/theme/colors";

export const CHART_COLOR_PRIMARY_600 = colors.teal600;
export const CHART_COLOR_PRIMARY_100 = colors.teal100;
export const CHART_COLOR_SECONDARY_600 = colors.coral600;
export const CHART_COLOR_MONO_500 = colors.mono500;
export const CHART_COLOR_MONO_100 = colors.mono100;
export const CHART_COLOR_GREY_200 = colors.grey200;
export const CHART_COLOR_PRIMARY_700 = colors.teal700;
